<template>
  <div class="overview">
    <el-row v-if="displayData.val2 == 'elevator'">
      <div style="height: 40px;" ></div>
    </el-row>
    <!--更换空间-->
    <el-row v-if="displayData.val1 === 'space' && displayData.val2 !== 'map' && displayData.val2 !== 'elevator'">
      <img src="../../assets/images/index/roomIcon.png"
           style="margin-left: 1.3vw;margin-top: 10px;float: left;margin-right: 5px;">
      <div style="line-height: 40px;">
        <span style="color: rgba(7, 230, 248, 1)">{{ currentSpaceInfo.title }}</span>
        <a class="pointer text-white" style="margin-left: 10px;" @touchstart="clickSpaceTree" @click="clickSpaceTree">更换空间</a>
      </div>
      <space-choose @close="spaceTreeDisable = false"
                    @spaceClick="spaceClick"
                    :currentSpaceInfo="currentSpaceInfo"
                    ref="spaceChoose" v-show="spaceTreeDisable"></space-choose>
    </el-row>

    <!--悬浮图标-->
    <FloatBall :displaySystem="displaySystem"
               :display-data="displayData"
               :code="code"
               @changeMode="changeMode"
               >
    </FloatBall>

    <div v-if="displayData.val1 === 'space'">
      <!--内景图展示-->
      <indoor-setting-view v-on:childByValue="childByValue" :currentSpaceInfo="currentSpaceInfo" :tagCode="tagCode" 
         :highlightDeviceId="highlightDeviceId" ref="indoor"
         @clearHighlight="clearHighlight"
         v-if="displayData.val2 === 'indoor' || displayData.val2 === 'elevator'"></indoor-setting-view>
      <!--组态列表展示-->
      <configuration-list-view
        v-if="displayData.val2 === 'list'"
        :currentSpaceInfo="currentSpaceInfo" :deviceCustomLayouts="deviceCustomLayouts"
        ref="configurationListView">
      </configuration-list-view>
      <!--GIS地图-->
      <t-d-map v-if="displayData.val2 === 'map'" @display="mapToIndoor"></t-d-map>
    </div>
    <div  v-if="displayData.val1 === 'allSpace'">
      <all-space-temperature-humidity></all-space-temperature-humidity>
    </div>

  </div>
</template>

<script>
import SpaceChoose from "@/views/overview/SpaceChoose";
import IndoorSettingView from "@/views/overview/IndoorSettingView";
import FloatBall from "@/views/overview/FloatBall";
import ConfigurationListView from "@/views/overview/ConfigurationListView";
import {getCustomPage, savePage} from "@/network/device-custom-page";
import {getSystematicByCodes} from "@/network/systematic";
import {getSpaceInfoById} from "@/network/space-info";
import AllSpaceTemperatureHumidity from "@/views/temperature_humidity/AllSpaceTemperatureHumidity";
import TDMap from "@/views/basic_operations/monitoring/device_list/TDMap";
import _ from 'lodash'

export default {
  name: "Overview",
  components: {
    IndoorSettingView,
    SpaceChoose,
    FloatBall,
    ConfigurationListView,
    AllSpaceTemperatureHumidity,
    TDMap,
  },
  data() {
    return {
      page: 'configurationList',
      currentSpaceInfo: {id: '0', title: '暂无空间'},
      dialogVisible: false,
      spaceTreeDisable: false,
      displaySystem: {},
      displayData: {},
      viewMode: '',
      selectMode: '',
      operation: '',
      deviceCustomPage: {},
      deviceCustomLayouts: [],
      code: "overview_display_mode",
      selectList: [{
        id: 1,
        name: '内景图',
        label: 'indoor',
      }, {
        id: 2,
        name: '组态列表',
        label: 'list',
      }],
      tagCode: '',
      highlightDeviceId: '', // 需要高亮显示的设备ID
    };
  },
  mounted() {
    // 先初始化 currentSpaceInfo，再调用 getByCodes
    this.initCurrentSpaceInfo();
    this.getByCodes();
    
    // 检查路由参数，如果有 deviceId，保存用于高亮显示（只设置一次）
    if (this.$route.query.deviceId) {
      this.highlightDeviceId = this.$route.query.deviceId;
    }
    
    // 检查路由参数，如果有 tagId 和 tagName，保存到 cookie（只用于子组件初始化）
    if (this.$route.query.tagId && this.$route.query.tagName) {
      const tagData = {
        tagId: this.$route.query.tagId,
        tagName: this.$route.query.tagName
      };
      this.$cookies.set("tagData", tagData);
    }
  },
  methods: {
    // 初始化当前空间信息
    initCurrentSpaceInfo() {
      // 1. 优先从路由参数获取
      if (this.$route.query.spaceId) {
        this.currentSpaceInfo = {
          id: this.$route.query.spaceId,
          title: this.$route.query.spaceName || '加载中...'
        };
        console.log('从路由参数初始化空间:', this.currentSpaceInfo);
        return;
      }
      
      // 2. 从 cookie 获取
      const cookieSpaceInfo = this.$cookies.get("currentSpaceInfo");
      if (cookieSpaceInfo) {
        try {
          const parsedInfo = typeof cookieSpaceInfo === 'string' ? 
            JSON.parse(cookieSpaceInfo) : cookieSpaceInfo;
          
          // 验证 spaceId 是否有效
          if (parsedInfo && parsedInfo.id && parsedInfo.id !== '0') {
            // 异步验证空间是否存在
            getSpaceInfoById(parsedInfo.id).then(res => {
              if (res.data) {
                this.currentSpaceInfo = parsedInfo;
                console.log('从 cookie 初始化空间:', this.currentSpaceInfo);
              } else {
                console.warn('cookie 中的空间信息无效，保持默认值');
              }
            }).catch(err => {
              console.error('验证空间信息失败:', err);
            });
            // 先设置，异步验证
            this.currentSpaceInfo = parsedInfo;
          }
        } catch (e) {
          console.error('解析 cookie 中的空间信息失败:', e);
        }
      } else {
        console.warn('未找到已保存的空间信息，等待用户选择空间');
      }
    },
    // 清除高亮设备ID
    clearHighlight() {
      this.highlightDeviceId = '';
    },
    clickSpaceTree(){
      this.spaceTreeDisable = !this.spaceTreeDisable;
      if (this.displayData.val2 === 'indoor' || this.displayData.val2 === 'elevator') {
      this.$refs.indoor.closeDetail();
      }
    },
    //更换按钮
    spaceClick(data, init) {
      if (this.displayData.val2 === 'indoor' || this.displayData.val2 === 'elevator') {
        this.$refs.indoor.closeDetail();
      }

      // 用户点击树节点切换空间
      if (!init) {
        this.currentSpaceInfo = data;
        // 防止子节点太大，清空子节点
        if (this.currentSpaceInfo.children) {
          this.currentSpaceInfo.children = [];
        }
        this.$cookies.set("currentSpaceInfo", JSON.stringify(data));
        this.spaceTreeDisable = false;
        this.getCustomPageInfo();
        return;
      }

      // 大屏跳转过来
      if (this.$route.query.spaceId) {
        this.currentSpaceInfo = {
          id: this.$route.query.spaceId, 
          title: this.$route.query.spaceName
        };
        
        
        this.$cookies.set("currentSpaceInfo", JSON.stringify(this.currentSpaceInfo));
        this.$router.replace('/overview');
      } else {
        const currentSpaceInfo = this.$cookies.get("currentSpaceInfo");
        
        if (currentSpaceInfo && init) {
          try {
            // 先尝试解析 cookie 中的数据
            const parsedInfo = typeof currentSpaceInfo === 'string' ? 
              JSON.parse(currentSpaceInfo) : currentSpaceInfo;

            getSpaceInfoById(parsedInfo.id).then(res => {
              if (res.data) {
                this.currentSpaceInfo = parsedInfo;
              } else {
                this.currentSpaceInfo = data;
                this.$cookies.set("currentSpaceInfo", JSON.stringify(data));
              }
            });
            // 节点选中
            this.$refs.spaceChoose.selectNode(parsedInfo);
          } catch (e) {
            console.error('解析 currentSpaceInfo 失败:', e);
            this.currentSpaceInfo = data;
            this.$cookies.set("currentSpaceInfo", JSON.stringify(data));
          }
        } else {
          this.currentSpaceInfo = data;
          // 防止子节点太大，清空子节点
          if (this.currentSpaceInfo.children) {
            this.currentSpaceInfo.children = [];
          }
          this.$cookies.set("currentSpaceInfo", JSON.stringify(data));
        }
        this.spaceTreeDisable = false;
        this.getCustomPageInfo();
      }
    },
    childByValue: function (childByValue) {
      // childValue就是子组件传过来的值
      if (childByValue === '停车'){
        this.displayData.val2 = 'elevator'
      }else {
        this.displayData.val1 ='space'
        this.displayData.val2 ='indoor'
      }
    },
    //获取展示方式配置
    getByCodes() {
      getSystematicByCodes(this.code).then(res => {
        if (res.code === 0) {
          this.displaySystem = res.data[0]
          if (this.$route.query.spaceId) {
            this.tagCode = this.$route.query.tagCode
            this.displayData = {
              val1: 'space',
              val2: 'indoor',
            }
          } else {
            this.displayData = _.cloneDeep(this.displaySystem)
          }
        }
      })
    },
    changeMode(val1,val2) {
      this.displayData.val1 = val1
      this.displayData.val2 = val2
    },
    getDisplayMode(val) {
      this.selectMode = val;
    },
    //获取自定义页面信息
    //获取组态列表自定义页面(没有则保存)
    getCustomPageInfo() {
      getCustomPage(this.page).then(res => {
        if (res.code === 0) {
          if (res.data === null) {
            let deviceCustomPageDto = {
              deviceCustomPage: {page: this.page, name: '组态列表'},
              deviceCustomLayouts: [{
                name: 'common',
                component: 'indoor',
                params: JSON.stringify({position: {left: 20, top: 0, width: 350, height: 290}}),
              }, {
                name: 'common',
                component: 'deviceTotal',
                params: JSON.stringify({position: {left: 20, top: 310, width: 350, height: 115}}),
              }]
            };
            savePage(deviceCustomPageDto).then(() => {
              this.getCustomPageInfo();
            })
          } else {
            this.deviceCustomPage = res.data.deviceCustomPage;
            if (res.data.deviceCustomLayouts.length > 0) {
              this.deviceCustomLayouts = res.data.deviceCustomLayouts
                .filter(item => item.name === this.currentSpaceInfo.id || item.name === 'common')
                .map(item => {
                  item.paramsData = JSON.parse(item.params);
                  return item;
                })
            }
          }
        }
      })
    },
    mapToIndoor(val){
      this.displayData.val2 = val
    }
  }
}
</script>

<style scoped>
</style>
